var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeelgoodWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 40,
    viewBox: "0 0 133 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FeelGood Logo-White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FeelGood Logo-White-\xEC\x97\xAC\xEB\xB0\xB1\xEC\x97\x86\xEC\x9D\x8C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.9949 14.679V12.3857H34.4219V27.6453H36.8547V21.3914H44.2087V19.0981L36.8547 19.1175V14.679H44.9949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.7103 16.3303C47.575 16.3303 45.2988 18.7635 45.2988 22.1162C45.2988 25.4689 47.575 27.9034 50.7103 27.9034C53.0986 27.9034 55.11 26.5698 55.7152 24.5854L55.8273 24.2156H53.3917L53.3188 24.3832C52.9662 25.1933 51.9166 25.7375 50.709 25.7375C49.1947 25.7375 48.0343 24.7183 47.7398 23.1701H56.0299L56.0637 22.9263C56.1029 22.6494 56.1029 22.3655 56.1029 22.1162C56.1029 18.7635 53.8348 16.3303 50.709 16.3303H50.7103ZM50.7103 18.4948C52.2476 18.4948 53.3904 19.4919 53.6957 21.0623H47.7398C48.0302 19.4919 49.169 18.4948 50.7103 18.4948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.5892 16.3303C59.4539 16.3303 57.1777 18.7635 57.1777 22.1162C57.1777 25.4689 59.4539 27.9034 62.5892 27.9034C64.9775 27.9034 66.9889 26.5698 67.5941 24.5854L67.7062 24.2156H65.2706L65.1977 24.3832C64.8451 25.1933 63.7955 25.7375 62.5879 25.7375C61.0736 25.7375 59.9132 24.7183 59.6187 23.1701H67.9088L67.9426 22.9263C67.9818 22.6494 67.9818 22.3655 67.9818 22.1162C67.9818 18.7635 65.7137 16.3303 62.5879 16.3303H62.5892ZM62.5892 18.4948C64.1265 18.4948 65.2693 19.4919 65.5746 21.0623H59.6187C59.9091 19.4919 61.0479 18.4948 62.5892 18.4948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.6341 11.9272H69.2363V27.6452H71.6341V11.9272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M81.6899 19.3738V21.6117H87.3635C87.019 23.9895 84.9563 25.6832 82.3437 25.6832C79.1463 25.6832 76.9133 23.3483 76.9133 20.0067C76.9133 16.6651 79.1314 14.3662 82.3073 14.3662C84.5645 14.3662 86.5381 15.6126 87.1068 17.399L87.1689 17.5957H89.7734L89.6775 17.2356C88.8453 14.1267 85.8681 12.0383 82.2721 12.0383C77.7576 12.0383 74.4805 15.3896 74.4805 20.0081C74.4805 24.6265 77.7576 27.9778 82.2721 27.9778C86.7867 27.9778 89.9557 24.7581 89.9557 20.3197V19.3752H81.6899V19.3738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M96.1504 16.3303C92.953 16.3303 90.6309 18.7635 90.6309 22.1162C90.6309 25.4689 92.9516 27.9034 96.1504 27.9034C99.3492 27.9034 101.651 25.4703 101.651 22.1162C101.651 18.7621 99.337 16.3303 96.1504 16.3303ZM96.1504 18.5682C97.97 18.5682 99.2898 20.0611 99.2898 22.1176C99.2898 24.1741 97.9686 25.6669 96.1504 25.6669C94.3322 25.6669 92.9921 24.1741 92.9921 22.1176C92.9921 20.0611 94.32 18.5682 96.1504 18.5682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M107.904 16.3303C104.707 16.3303 102.385 18.7635 102.385 22.1162C102.385 25.4689 104.706 27.9034 107.904 27.9034C111.103 27.9034 113.405 25.4703 113.405 22.1162C113.405 18.7621 111.091 16.3303 107.904 16.3303ZM107.904 18.5682C109.724 18.5682 111.044 20.0611 111.044 22.1176C111.044 24.1741 109.723 25.6669 107.904 25.6669C106.086 25.6669 104.746 24.1741 104.746 22.1176C104.746 20.0611 106.074 18.5682 107.904 18.5682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M122.835 11.9272V17.6148C122.146 16.9168 121.022 16.3297 119.481 16.3297C116.436 16.3297 114.141 18.8168 114.141 22.1155C114.141 25.4142 116.437 27.9028 119.481 27.9028C121.022 27.9028 122.146 27.3156 122.835 26.6163V27.6452H125.232V11.9272H122.835ZM119.641 25.6649C117.792 25.6649 116.502 24.2052 116.502 22.1155C116.502 20.0258 117.793 18.5662 119.641 18.5662C121.489 18.5662 122.871 20.059 122.871 22.1155C122.871 24.172 121.514 25.6649 119.641 25.6649Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20.3472 23.1736V16.7327H20.3459C16.8769 16.7327 14.0645 19.6159 14.0645 23.1722C14.0645 26.7284 16.8769 29.6117 20.3459 29.6117C23.8148 29.6117 26.6259 26.7298 26.6273 23.1736H20.3472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.7832 10.2913V16.5909V23.1717H14.0646V16.7322H17.4417V10.2913H7.7832Z",
    fill: "white"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelgoodWhiteLogo);
export default __webpack_public_path__ + "static/media/feelgood_white_logo.105785ba2d98f53b27f4ae780607349e.svg";
export { ForwardRef as ReactComponent };